import { FC } from 'react';

import { useLmmSidepanelState } from '@/apps/lmm/state/selectors/useLmmSidepanelStore';
import MaterieelDetailsPanel from '@/components/detailPanel/materieelDetails/MaterieelDetailsPanel';
import { useMaterieelEigenschappen } from '@/components/detailPanel/materieelDetails/useMaterieelEigenschappen';
import { defectSorter } from '@/domain/defecten/defectSorter';
import { Eenheid } from '@/types/werklijnenInline';

import useLmmStore from '../../state/useLmmStore';

import { lmmMaterieelBron, splitMaterieelType } from './lmmMaterieelType';

type LmmMaterieelPanelProps = {
  onClose: () => void;
  onBack?: () => void;
};

const LmmMaterieelPanel: FC<LmmMaterieelPanelProps> = ({ onClose, onBack }) => {
  const { lmmVoorraad, geselecteerdeDefect } = useLmmSidepanelState();
  const geselecteerdEenheidNummer = geselecteerdeDefect?.eenheidNummer;
  const defecten = useLmmStore((state) => {
    const eenheidDefecten = geselecteerdEenheidNummer
      ? state.defecten.filter(
          (defect) => geselecteerdEenheidNummer && defect.eenheidNummer === geselecteerdEenheidNummer,
        )
      : [];
    eenheidDefecten.sort(defectSorter);
    return eenheidDefecten;
  });
  const { eigenschappen } = useMaterieelEigenschappen(geselecteerdEenheidNummer);

  const materieelPanelData: Eenheid | undefined = geselecteerdeDefect
    ? {
        nummer: geselecteerdeDefect.eenheidNummer,
        materieelType: splitMaterieelType(lmmMaterieelBron(geselecteerdeDefect.materieelSoort, lmmVoorraad?.materieel)),
      }
    : undefined;

  return (
    <MaterieelDetailsPanel
      materieelPanelData={materieelPanelData}
      eigenschappen={eigenschappen}
      defecten={defecten}
      onClose={onClose}
      onBack={onBack}
    />
  );
};

export default LmmMaterieelPanel;
